import React from "react";
import ReactDOM from "react-dom/client";
// import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./store/AuthContext";

// Suppress console warnings in production build
if (process.env.NODE_ENV === 'production') {
  const originalWarn = console.warn;
  console.warn = (...args) => {
    // Filter out React Router future flag warnings and other non-critical warnings
    const message = args[0];
    if (typeof message === 'string') {
      // Skip React Router future flag warnings
      if (message.includes('React Router Future Flag Warning')) return;
      if (message.includes('v7_startTransition')) return;
      if (message.includes('v7_relativeSplatPath')) return;
      // Skip other common React warnings that don't affect functionality
      if (message.includes('Warning: React does not recognize')) return;
      if (message.includes('Warning: Failed prop type')) return;
    }
    // Allow other warnings to pass through
    originalWarn.apply(console, args);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
